const workflow = {
  workflow: {
    options: {
      min: {
        icon: 'turtle',
        value: '1400'
      },
      eco: {
        icon: 'leaf',
        value: '2000'
      },
      max: {
        icon: 'rabbit',
        value: '3000'
      }
    },
    engineNotStartedValues: [
      {
        icon: 'icon-xm-battery',
        value: '14.5'
      },
      {
        icon: 'icon-xm-bar-wind',
        value: ''
      },
      {
        icon: 'icon-xm-drop-wrench',
        value: '713.2'
      },
      {
        icon: 'icon-xm-flask-wrench',
        value: '313.2'
      }
    ]
  }
};

export default workflow;



// WEBPACK FOOTER //
// ./src/screens/data/flow3/workflow.js